<template>
  <div class="home_page inquiry_detail">
    <el-header class="right-menu-name" height="40px">
      <el-breadcrumb separator="/" style="line-height:40px">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="detail_content">
      <div class="detail_title">
        <el-col :span="12">
          <h2>询价单详情</h2>
        </el-col>
        <el-col :span="12">状态：{{$getDictLabel('INQUIRY_STATUS', detailInfo ? detailInfo.status : '')}}</el-col>
      </div>
      <div v-if="detailInfo">
        <el-row>
          <el-col :span="12">询价单号：{{detailInfo.inquiryNo}}</el-col>
          <el-col :span="12">提交时间：{{detailInfo.createTime}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="12">用户名：{{detailInfo.name}}</el-col>
          <el-col :span="12">联系电话：{{detailInfo.mobile}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="12">所属公司：{{detailInfo.companyName}}</el-col>
          <el-col :span="12">业务部门：{{detailInfo.userServiceShopName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3">询价商品：</el-col>
          <el-col :span="21">
            <el-table :data="detailInfo.commodityVos"
                      style="width: 100%;line-height: 20px;"
                      border>
              <el-table-column
                prop="skuCode"
                label="商品编号"
                header-align="center"
                align="center"
                width="180">
              </el-table-column>
              <el-table-column
                prop="skuName"
                label="商品名称"
                header-align="center"
                align="center">
                <template slot-scope="scope">
                  <span @click="goGoodDetail(scope.row)"
                        class="cursor-pointer">{{scope.row.skuName}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="model"
                label="商品型号"
                header-align="center"
                align="center"
                width="180">
              </el-table-column>
              <el-table-column
                prop="count"
                label="商品数量"
                header-align="center"
                align="center"
                width="180">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">询价备注：</el-col>
          <el-col :span="21">{{detailInfo.remark}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3">询价附件：</el-col>
          <el-col :span="21">
            <ol style="margin: 0; padding: 0; list-style-type:none; color: #409eff;">
              <li v-for="(item) in detailInfo.sysOssEntities"
                  :key="item.aliOssId"
                  >
                  <!-- {{index + 1}}、 -->
                <span @click="downLoad(item)"
                      class="cursor-pointer">{{item.fileName}}</span>
              </li>
            </ol>
          </el-col>
        </el-row>
        <el-row v-show="detailInfo.status!=='10'">
          <el-col :span="3">受理意见：</el-col>
          <el-col :span="21">{{detailInfo.acceptFeedback}}</el-col>
        </el-row>
        <el-row v-show="detailInfo.status!=='10'">
          <el-col :span="3">报价附件：</el-col>
          <el-col :span="21">
            <ol style="margin: 0; padding: 0; list-style-type:none; color: #409eff;">
              <li v-for="(item) in detailInfo.feedbackOssEntities"
                  :key="item.aliOssId">
                  <!-- {{index + 1}}、 -->
                <span @click="downLoad(item)"
                      class="cursor-pointer">{{item.fileName}}</span>
              </li>
            </ol>
          </el-col>
        </el-row>
        <!-- 商城端不存在单个催促受理 -->
        <!-- <div v-show="detailInfo.status==='10'" class="text-center">
          <el-button class="but_plant"
                     type="primary"
                     @click="urgeHandle"
                     :disabled="loading"
                     :loading="loading"
                     v-if="$hasPermission('front:inquiry:urge')">催促受理</el-button>
        </div> -->
        <!-- 确认订单/驳回 -->
        <div v-show="detailInfo.status==='17'" class="text-center">
          <el-button class="but_plant"
                     @click="rejectHandle"
                     :disabled="loading"
                     :loading="loading">不同意</el-button>
          <el-button class="but_plant"
                     type="primary"
                     @click="agreeHandle"
                     :disabled="loading"
                     :loading="loading">同意报价</el-button>
                     <!-- v-if="$hasPermission('front:inquiry:urge')" -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
export default {
  name: 'inquiryDetail', // 询价单详情
  data () {
    return {
      loading: false,
      detailInfo: null
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    // 查询活动详情
    getInfo () {
      this.detailInfo = null
      if (!this.$route.query.id) {
        return false
      }
      this.$request.get(`/front/consumer/inquirysheet/inquirySheetInfo/${this.$route.query.id}`)
        .then(res => {
          this.detailInfo = res
        })
    },
    // 下载附件
    downLoad (item) {
      if (item.url) {
        openOther(item.url, true)
      }
    },
    // 催促受理
    urgeHandle () {
      if (!this.detailInfo || !this.detailInfo.inquiryId) {
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      this.$http.post(`/help/consumer/inquirysheet/urgeAcceptanceInquirySheet`, [
        { inquiryId: this.detailInfo.inquiryId }
      ])
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success('催促成功')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 跳转商品详情
    goGoodDetail (row) {
      openOther(`goodDetail?spuId=${row.spuId}&skuId=${row.skuId}`)
    },
    // 驳回报价
    rejectHandle () {
      if (this.loading) {
        return false
      }
      this.$confirm('确认驳回报价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmHandle('16')
      }).catch(() => { })
    },
    // 确认报价
    agreeHandle () {
      if (this.loading) {
        return false
      }
      this.$confirm('确认报价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmHandle('18')
      }).catch(() => { })
    },
    // 确认报价
    confirmHandle (status = '18') {
      if (this.loading) {
        return false
      }
      this.loading = true
      this.$http.post(`/help/consumer/inquirysheet/confirmInquiry`, {
        inquiryId: this.$route.query.id,
        status: status
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success(`${status === '16' ? '驳回 ' : '确认'}催促成功`)
          this.$router.push({
            name: 'inquiryList'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.inquiry_detail{
  .detail_content{
    background-color: #fff;
    padding: 30px 125px;
    .detail_title{
      display: flex;
      align-items: center;
      line-height: 40px;
      color: #666;
      font-size: 18px;
      // justify-content: center;
    }
    .el-row{
      line-height: 40px;
      color: #666;
      font-size: 18px;
    }
    .but_plant{
      min-width: 150px;
    }
  }
}
</style>
